export default "__VITE_ASSET__D_IZCEEG__"